import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function XIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'X',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>X</title>

			<path
				d="M30.5348 0H9.46517C4.2377 0 0 4.2377 0 9.46517V30.5348C0 35.7623 4.2377 40 9.46517 40H30.5348C35.7623 40 40 35.7623 40 30.5348V9.46517C40 4.2377 35.7623 0 30.5348 0Z"
				fill={bg}
			/>

			<path
				d="M11.2 9.5H15.8L20.5 15.9L25.8 9.5H29.3L22.1 18.1L30 30.5H24.2L19.1 23.2L13.1 30.5H9.6L17.5 20.9L11.2 9.5ZM15.3 11.9L25 28.1H25.9L16.1 11.9H15.3Z"
				fill={g}
			/>
		</svg>
	);
}
